import showWaveEffect from './WaveEffect';
export default function useWave(nodeRef, className) {
  function showWave() {
    const node = nodeRef.current;
    showWaveEffect(node, className);
  }
  return showWave;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/wave/useWave.js
// module id = 1673
// module chunks = 0